$( document ).ready(function() {
    window['_fs_ready'] = function() {
        sessionUrlAtTime = FS.getCurrentSessionURL();
        $("#fsurl").val(sessionUrlAtTime);
    };
    $('.button-contact').click(function(e) {
        e.preventDefault();
        sendForm($('#contactform'));
    });
    $('[name="name"]').keyup(function ()    { resetFormField('name', 'Your name:'); });
    $('[name="email"]').keyup(function ()   { resetFormField('email', 'Your email address:'); });
    $('[name="message"]').keyup(function () { resetFormField('message', "What's your question or query?"); });
});

function resetFormField($id, $message) {
    $("label[for='"+$id+"']").html($message);
    $("label[for='"+$id+"']").addClass('form-error');
    $('[name="'+$id+'"]').closest('.form-group').removeClass('invalid');
}

function sendForm($formName) {
    var data = $($formName).serialize();
    $.ajax({
        type: "POST",
        data: data,
        url: "/contact",
        success: function (data) {
            let errorCount = data.errorCount;
            if(data.errorCount > 0) {
                let errors = data;
                $.each( errors , function( key, value ) {
                    let firstValue = value.toString().split(',')[0];
                    $("label[for='"+key+"']").html(firstValue);
                    $("label[for='"+key+"']").addClass('form-error');
                    $('[name='+key+']').closest('.form-group').addClass('invalid');
                });
                goToError();
            } else {
                top.location='/contact-sent';
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
        }
    });
}

function goToError() {
    if ($('div').hasClass('invalid')) {
        $('html, body').animate(
            {
              scrollTop: $(".invalid").first().offset().top,
            },
            250,
            'linear'
        );
    }
}
